var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Users / User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 11.6666C16.5773 11.6666 18.6666 9.57731 18.6666 6.99998C18.6666 4.42265 16.5773 2.33331 14 2.33331C11.4227 2.33331 9.33331 4.42265 9.33331 6.99998C9.33331 9.57731 11.4227 11.6666 14 11.6666Z",
    fill: "#47BDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.3334 20.4167C23.3334 23.3162 23.3334 25.6667 14 25.6667C4.66669 25.6667 4.66669 23.3162 4.66669 20.4167C4.66669 17.5172 8.84536 15.1667 14 15.1667C19.1547 15.1667 23.3334 17.5172 23.3334 20.4167Z",
    fill: "#47BDFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlue);
export default __webpack_public_path__ + "static/media/user_blue.1779eeb55bd8da7b416ebeb48c10dd4c.svg";
export { ForwardRef as ReactComponent };